import React from 'react';
import { CheckCircle, HardHat } from 'lucide-react';
import { areasServicio } from '../mock';

const AreaConstruccion = () => {
  const area = areasServicio.construccion;
  
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="hero-section py-24">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <div className="inline-block mb-6">
                <span className="px-4 py-2 bg-yellow-400/20 text-yellow-400 rounded-full text-sm font-semibold backdrop-blur-sm border border-yellow-400/30">
                  Construcción Profesional
                </span>
              </div>
              <h1 className="text-5xl lg:text-6xl font-bold heading-font mb-6">
                {area.titulo}
              </h1>
              <p className="text-xl text-gray-200 leading-relaxed">
                {area.descripcion}
              </p>
            </div>
            <div className="relative">
              <img
                src={area.imagen}
                alt={area.titulo}
                className="rounded-2xl shadow-2xl"
              />
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gradient-to-br from-blue-500/20 to-yellow-500/20 rounded-2xl blur-3xl"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Servicios */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold heading-font mb-4">
              Servicios de Construcción
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Proyectos ejecutados con los más altos estándares de calidad
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
            {area.servicios.map((servicio, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow"
              >
                <CheckCircle className="w-6 h-6 text-green-500 mt-1 flex-shrink-0" />
                <p className="text-gray-700 font-medium">{servicio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Ventajas 
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold heading-font mb-8">Ventajas de Trabajar con Nosotros</h2>
              <div className="space-y-6">
                {[
                  { title: 'Proyectos Llave en Mano', desc: 'Nos encargamos de todo el proceso constructivo' },
                  { title: 'Cumplimiento de Plazos', desc: 'Entrega en tiempo y forma según lo acordado' },
                  { title: 'Control de Calidad', desc: 'Supervisión constante en cada etapa del proyecto' },
                  { title: 'Permisos y Normativas', desc: 'Gestión completa de permisos municipales' }
                ].map((item, idx) => (
                  <div key={idx} className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-full bg-yellow-400 flex items-center justify-center flex-shrink-0">
                      <CheckCircle className="w-6 h-6 text-blue-900" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                      <p className="text-gray-600">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBidWlsZGluZ3xlbnwwfHx8fDE3ODE1ODA0ODZ8MA&ixlib=rb-4.1.0&q=85"
                alt="Construcción"
                className="rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>*/}

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-blue-950 text-white">
        <div className="container mx-auto px-4 text-center">
          <HardHat className="w-16 h-16 text-yellow-400 mx-auto mb-6" />
          <h2 className="text-4xl lg:text-5xl font-bold heading-font mb-6">
            ¿Tienes un Proyecto en Mente?
          </h2>
          <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto">
            Conversemos sobre tu proyecto de construcción
          </p>
            <a href='/proyectos'>
            <button className="btn-primary text-lg px-8 py-4">
              Solicitar Cotización
            </button>
            </a>
        </div>
      </section>
    </div>
  );
};

export default AreaConstruccion;